var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('div',{staticClass:"px-4 py-5 sm:p-6 uppercase"},[_c('h3',{staticClass:"text-2xl text-gray-300 text-center py-10"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }